module.exports = __webpack_public_path__ + "static/media/generalsettings.6342948f.svg";